import React from 'react';
import { connect } from 'react-redux';

import { logEvent } from '../../../services/log';

import { IApplicationState } from '../../../store/applicationState';
import { IDocument, IGroup } from '../../../store/group/groupState';

interface IStateProps {
    viewerIsDi: boolean;
    groupOwner: IGroup | null;
}

interface IOwnProps {
    document: IDocument;
    className: string;
    title?: string;
    children: React.ReactNode;
}

type Props = IStateProps & IOwnProps;

class AttachmentLink extends React.Component<Props, {}> {
    public render() {
        return <a href={`/attachments/${encodeURI(this.props.document.id)}`} className={this.props.className} target="_blank" rel="nofollow noopener noreferrer" onMouseUp={this.trackDownload} title={this.props.title}>
            {this.props.children}
        </a>;
    }

    private trackDownload = () => {
        if (!this.props.viewerIsDi) {
            logEvent('dokument download', this.props.document.id, this.props.document.fileName, this.props.groupOwner);
        }
    }
}


const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        viewerIsDi: state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.role === 'DI',
        groupOwner: (state.groupData.currentGroup && state.groupData.groups.groups.byId[state.groupData.currentGroup]) || null
    };
}

const container = connect(mapStateToProps)(AttachmentLink);

export default container;